<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="icon_infos">
      <div class="info_lefts" style="min-width: 400px">
        <template>
          <div class="item_box active_Info_name" v-if="info">
            <div class="top_head">
              <img :src="info.head"/>
            </div>
            <div class="box_info_infos">
              <div>{{ info.name }}({{ info.number }})</div>
              <div>投放组：{{ info.advertiserDeptName}}</div>
            </div>
          </div>
          <div class="item_box" v-if="salesTransactionInfo.tfs">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <div> 我的投放渠道 <span style="margin-left:5px;">（{{ salesTransactionInfo.tfs.length }}）</span></div>
              <div :class="{'active_box':changAppNum>10,'nowMore':changAppNum<=10}" @click="changNums">
                <i v-if="salesTransactionInfo.tfs.length>10" style="font-size: 25px;color: #959595"
                   class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="info_list_tabs">
              <div class="info_item" v-for="(item,index) in salesTransactionInfo.tfs.slice(0,changAppNum)" :key="index">
                <div class="left_box">
                  <img :src="item.icon">
                </div>
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                  <div class="right_infos">
                    <div>{{ item.name }}</div>
                    <div>sou：{{ item.code }}</div>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="item_box" v-if="salesTransactionInfo.cks">
            <div style="display: flex;align-items: center;justify-content: space-between">
              <div> 我的查看渠道 <span style="margin-left:5px;">（{{ salesTransactionInfo.cks.length }}）</span></div>
              <div :class="{'active_box':accountsNum>10,'nowMore':accountsNum<=10}" @click="changSceNums">
                <i v-if="salesTransactionInfo.cks.length>10" style="font-size: 25px;color: #959595"
                   class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="info_list_tabs">
              <div class="info_item" v-for="(item,index) in salesTransactionInfo.cks.slice(0,accountsNum)" :key="index">
                <div class="left_box">
                  <img :src="item.icon">
                </div>
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                  <div class="right_infos">
                    <div>{{ item.name }}</div>
                    <div>sou：{{ item.code }}</div>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="box_infos ">
        <div class="chang_box_info_case car_insdoasd" style="display: flex">
          <div class="chang_box_content" style="display: inline-block">
            <div class="chin_box_title" v-if="salesTransactionInfo.library">
              <div class="div_name">创意库</div>
              <div class="box_info_tabs">
                <div class="box_name_tabs">
                  <div>创意</div>
                  <div class="content_box">{{ salesTransactionInfo.library.total?salesTransactionInfo.library.total:0 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近30日</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.library.advert_30>=0">+</span> {{ salesTransactionInfo.library.advert_30 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近15日</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.library.advert_15>=0">+</span> {{ salesTransactionInfo.library.advert_15 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近7日</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.library.advert_7>=0">+</span> {{ salesTransactionInfo.library.advert_7 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>今日新增</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.library.advert_1>=0">+</span> {{ salesTransactionInfo.library.advert_1 }}</div>
                </div>
                <div class="box_name_tabs" style="margin-right: 0">
                  <div>优选</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.library.optimi>=0">+</span> {{ salesTransactionInfo.library.optimi }}</div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 0" class="chin_box_title" v-if="salesTransactionInfo.advertiser">
              <div class="div_name">我的创意</div>
              <div class="box_info_tabs">
                <div class="box_name_tabs">
                  <div>创意</div>
                  <div class="content_box">{{ salesTransactionInfo.advertiser.total?salesTransactionInfo.advertiser.total:0 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近30日</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.advertiser.advert_30>=0">+</span> {{ salesTransactionInfo.advertiser.advert_30 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近15日</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.advertiser.advert_15>=0">+</span> {{ salesTransactionInfo.advertiser.advert_15 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>近7日</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.advertiser.advert_7>=0">+</span> {{ salesTransactionInfo.advertiser.advert_7 }}</div>
                </div>
                <div class="box_name_tabs">
                  <div>今日新增</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.advertiser.advert_1>=0">+</span> {{ salesTransactionInfo.advertiser.advert_1 }}</div>
                </div>
                <div class="box_name_tabs" style="margin-right: 0">
                  <div>优选</div>
                  <div class="content_box"><span style="color: #D9001B" v-if="salesTransactionInfo.advertiser.optimi>=0">+</span> {{ salesTransactionInfo.advertiser.optimi }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab_box_info">
            <div class="tip_name">创意达人</div>
<!--            style="border-top: 1px solid rgba(0,0,0,0.2);"-->
            <div class="tab_tr" >
              <div>排名</div>
              <div>专员</div>
              <div>创意</div>
              <div>优选</div>
            </div>
            <div class="tab_tr" v-for="(item,index) in salesTransactionInfo.ranks">
              <div :class="{'one':index==0,'two':index==1,'three':index==2}">{{index+1}}</div>
              <div :title="item.name+'('+item.number+')'">{{item.name}}({{item.number}})</div>
              <div>{{ item. total}}</div>
              <div>{{ item. optimi}}</div>
            </div>
          </div>
        </div>
        <div class="line" style="margin-top: 20px"></div>
        <div class="chineac_box">
          <div @click="changActiveModeItem('exam')" :class="{'active_div':bizType=='exam'}">测评</div>
          <div @click="changActiveModeItem('znqm')" :class="{'active_div':bizType=='znqm'}">起名</div>
          <div @click="changActiveModeItem('taluo')" :class="{'active_div':bizType=='taluo'}">塔罗</div>
        </div>
        <div class="chang_box_info_case">
          <div style="margin-bottom: 20px">
            <el-select filterable v-model="channelPieAccountId" placeholder="请选择">
              <el-option
                  :key="0"
                  label="全部"
                  :value="0">
              </el-option>
              <el-option
                  v-for="item in channelData"
                  :key="item.channelAccountId"
                  :label="item.name+'('+item.code+')'"
                  :value="item.channelAccountId">
              </el-option>
            </el-select>
            <el-button @click="channelOrderFluxClick" style="margin-left:10px" icon="el-icon-search" type="primary"
                       size="medium"></el-button>
          </div>
          <div style="min-height: 421px" v-loading="loadinChannel">
            <div class="chang_box_content" v-if="channelInfo.order">
              <div class="chin_box_title" style="margin-right: 20px">
                <div class="div_name" v-if="bizType=='exam'">测评订单</div>
                <div class="div_name" v-if="bizType=='znqm'">起名订单</div>
                <div class="div_name" v-if="bizType=='taluo'">塔罗订单</div>
                <div class="box_info_tabs">

                  <el-tooltip class="" effect="dark" :content="'总支付金额：'+channelInfo.order.totalMoney"
                              placement="top-start">
                    <div class="box_name_tabs">
                      <div>支付</div>
                      <div class="content_box">{{ channelInfo.order.total }}</div>
                    </div>
                  </el-tooltip>
                  <el-tooltip class="" effect="dark" :content="'月支付金额：'+channelInfo.order.monthMoney"
                              placement="top-start">
                    <div class="box_name_tabs">
                      <div>近30天</div>
                      <div class="content_box">{{ channelInfo.order.month }}</div>
                    </div>
                  </el-tooltip>

                  <el-tooltip class="" effect="dark" :content="'近15天支付金额：'+channelInfo.order.month15Money"
                              placement="top-start">
                    <div class="box_name_tabs">
                      <div>近15天</div>
                      <div class="content_box">{{ channelInfo.order.month15 }}</div>
                    </div>
                  </el-tooltip>
                  <el-tooltip class="" style="margin-right: 0" effect="dark"
                              :content="'日支付金额：'+channelInfo.order.dayMoney"
                              placement="top-start">
                    <div class="box_name_tabs" style="margin-right: 0">
                      <div>今日</div>
                      <div class="content_box">{{ channelInfo.order.day }}</div>
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="chin_box_title" v-if="bizType=='exam'">
                <div class="div_name">测评流量</div>
                <div class="box_info_tabs">
                  <div class="box_name_tabs">
                    <div>抵达</div>
                    <div class="content_box">
                      {{ channelInfo.flux.total }}
                    </div>
                  </div>
                  <div class="box_name_tabs">
                    <div>答题</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.begin }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.beginRate }}%</span>
                    </div>
                  </div>
                  <div class="box_name_tabs">
                    <div>完测</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.sub }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.subRate }}%</span>
                    </div>
                  </div>
                  <div class="box_name_tabs" style="margin-right: 0">
                    <div>支付</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.pay }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.payRate }}%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chin_box_title" v-if="bizType=='znqm'">
                <div class="div_name">起名流量</div>
                <div class="box_info_tabs">
                  <div class="box_name_tabs">
                    <div>抵达</div>
                    <div class="content_box">
                      {{ channelInfo.flux.total }}
                    </div>
                  </div>
                  <div class="box_name_tabs">
                    <div>起名</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.begin }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.beginRate }}%</span>
                    </div>
                  </div>
                  <div class="box_name_tabs">
                    <div>支付</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.pay }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.payRate }}%</span>
                    </div>
                  </div>
                  <el-tooltip style="white-space: pre-wrap" class="" effect="dark" :content="'已出生：'+channelInfo.flux.birth+'('+channelInfo.flux.birthRate+'%)'+'\n'+'未出生：'+channelInfo.flux.unbirth+'('+channelInfo.flux.unbirthRate+'%)'"
                              placement="top-start">
                    <div class="box_name_tabs" style="margin-right: 0">
                      <div>出生状态</div>
                      <div class="content_box clasdsad_infasas">
                        <span class="Rate_num">{{ channelInfo.flux.birthRate }}%</span>
                        <span class="Rate_num">{{ channelInfo.flux.unbirthRate }}%</span>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <div class="chin_box_title" v-if="bizType=='taluo'">
                <div class="div_name">塔罗流量</div>
                <div class="box_info_tabs">
                  <div class="box_name_tabs">
                    <div>抵达</div>
                    <div class="content_box">
                      {{ channelInfo.flux.total }}
                    </div>
                  </div>
                  <div class="box_name_tabs">
                    <div>占卜</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.begin }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.beginRate }}%</span>
                    </div>
                  </div>
                  <div class="box_name_tabs">
                    <div>提交</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.sub }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.subRate }}%</span>
                    </div>
                  </div>
                  <div class="box_name_tabs" style="margin-right: 0">
                    <div>支付</div>
                    <div class="content_box clasdsad_infasas">
                      <span>{{ channelInfo.flux.pay }}</span>
                      <span class="Rate_num">{{ channelInfo.flux.payRate }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cakeBox">
              <div class="pie_car">
                <pie-chart v-if="channelAgeShow" :report="channelAge"></pie-chart>
              </div>
              <div class="pie_car">
                <pie-chart v-if="channelSexShow" :report="channelSex"></pie-chart>
              </div>
              <div class="pie_car">
                <pie-chart v-if="channelEquipmentShow" :report="channelEquipment"></pie-chart>
              </div>
              <div class="pie_car" style="margin-right: 0">
                <pie-chart v-if="channelRegionShow" :report="channelRegion"></pie-chart>
              </div>
            </div>
          </div>

        </div>
        <div class="chineac_box" v-if="numberShow">
          <div @click="changActiveItem(1)" :class="{'active_div':activeTypeNum==1}">支付订单</div>
          <div @click="changActiveItem(2)" :class="{'active_div':activeTypeNum==2}">支付金额</div>
          <div @click="changActiveItem(3)" :class="{'active_div':activeTypeNum==3}">渠道流量</div>
        </div>
        <template v-if="activeTypeNum==1">
          <div class="pay_number" v-loading="loadingnNumberShow">
            <el-select @change="sucsNumChang" v-model="sucsLimit" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="sucsNumChang" style="margin-left: 10px" icon="el-icon-refresh" type="primary"
                       size="medium"></el-button>
            <curve-chart v-if="numberShow" :mode="channelPieAccountId" :report="salesTransaction"></curve-chart>
          </div>
        </template>
        <template v-if="activeTypeNum==2">
          <div class="pay_number" v-loading="loadingnPayShow">
            <el-select @change="moneyNumChang" v-model="moneyLimit" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="moneyNumChang" style="margin-left: 10px" icon="el-icon-refresh" type="primary"
                       size="medium"></el-button>
            <curve-chart v-if="payShow" :mode="channelPieAccountId" :report="salesDayTransaction"></curve-chart>
          </div>
        </template>
        <template v-if="activeTypeNum==3">
          <div class="pay_number" v-loading="loadingnChanneShow">
            <el-select @change="channeNumChang" v-model="channeLimit" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="channeNumChang" style="margin-left: 10px" icon="el-icon-refresh" type="primary"
                       size="medium"></el-button>
            <curve-chart :mode="channelPieAccountId" v-if="channeShow" :report="channeTransaction"></curve-chart>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import ColumnChart from "./components/ColumnChart";
import CurveChart from "./components/CurveChart";
import pieChart from "./components/pieChart";

export default {
  name: "logHome",
  components: {ColumnChart, CurveChart, pieChart},
  data() {
    return {
      loading: false,
      salesTransaction: {},
      salesDayTransaction: {},
      salesTransactionInfo: {},
      channeTransaction: {},
      numberShow: false,
      payShow: false,
      channeShow: false,
      info: {},
      changAppNum: 10,
      accountsNum: 10,
      options: [
        {
          value: 7,
          label: '近7天'
        }, {
          value: 15,
          label: '近15天'
        }, {
          value: 30,
          label: '近30天'
        }
      ],
      sucsLimit: 15,
      moneyLimit: 15,
      channeLimit: 15,
      loadingnNumberShow: false,
      loadingnPayShow: false,
      loadingnChanneShow: false,
      channelData: [],
      channelAccountId: 0,
      activeTypeNum: 1,
      bizType: 'exam',
      statisticalUserInfo: {},
      age: {},
      ageShow: false,
      sex: {},
      sexShow: false,
      equipment: {},
      equipmentShow: false,
      region: {},
      regionShow: false,
      channelInfo: {},
      channelAge: {},
      channelAgeShow: false,
      channelSex: {},
      channelSexShow: false,
      channelEquipment: {},
      channelEquipmentShow: false,
      channelRegion: {},
      channelRegionShow: false,
      channelPieAccountId: 0,
      loadinChannel: false,
    }
  },
  mounted() {
    // this.getPayList()
    this.getPaySucsList()
    this.maneyInfd()
    this.channelList()
    this.statisticalUser()
    this.channelOrderFlux()
  },
  computed: {
    getViewPortHeight() {
      return document.documentElement.clientWidth || document.body.clientWidth;
    }
  },
  methods: {
    async channelList() {
      const {data: resData} = await this.$get("channel/account/list?paging=false", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      this.channelData = resData.data;
      this.channelAccountId = resData.data[0].channelAccountId
    },

    async statisticalUser() {
      const {data: resData} = await this.$get("/console/stats/user/info");
      if (resData.result != 200) {
        return;
      }
      this.statisticalUserInfo = resData.data

      let ageObj = {
        id: 'userAge',
        name: '用户年龄',
        data: resData.data.age.data,
        width: '230px',
        height: '230px'
      }
      this.age = ageObj
      this.ageShow = true
      let sexObj = {
        id: 'userSex',
        name: '用户性别',
        data: resData.data.sex.data,
        width: '230px',
        height: '230px'
      }
      this.sex = sexObj
      this.sexShow = true
      let equipmentObj = {
        id: 'userEquipment',
        name: '使用设备',
        data: resData.data.device.data,
        width: '230px',
        height: '230px'
      }
      this.equipment = equipmentObj
      this.equipmentShow = true
      let regionObj = {
        id: 'useRegion',
        name: '地域分布 * 前十名',
        data: resData.data.district.data,
        width: '230px',
        height: '230px'
      }
      this.region = regionObj
      this.regionShow = true
    },

    async channelOrderFlux() {
      this.loadinChannel = true
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = "/console/stats/channel/order/flux?channelAccountId=" + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = "/console/stats/channel/order/flux?bizType=" + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);
      if (resData.result != 200) {
        this.loadinChannel = false
        return;
      }
      this.loadinChannel = false
      this.channelInfo = resData.data
      let arrName = ''
      if(this.bizType=='exam'){
        arrName = '用户年龄'
      }else if(this.bizType=='znqm'){
        arrName = '宝宝性别'
      }else if(this.bizType=='taluo'){
        arrName = '年龄区间'
      }
      let channelAgeObj = {
        id: 'channelAge',
        name: arrName,
        data: resData.data.age.data,
        width: '230px',
        height: '230px'
      }
      this.channelAge = channelAgeObj
      this.channelAgeShow = true
      let channelSexObj = {
        id: 'channelSex',
        name: '用户性别',
        data: resData.data.sex.data,
        width: '230px',
        height: '230px'
      }
      this.channelSex = channelSexObj
      this.channelSexShow = true
      let channelEquipmentObj = {
        id: 'channelEquipment',
        name: '使用设备',
        data: resData.data.device.data,
        width: '230px',
        height: '230px'
      }
      this.channelEquipment = channelEquipmentObj
      this.channelEquipmentShow = true
      let channelRegionObj = {
        id: 'channelRegion',
        name: '地域分布 * 前十名',
        data: resData.data.district.data,
        width: '230px',
        height: '230px'
      }
      this.channelRegion = channelRegionObj
      this.channelRegionShow = true

    },

    channelOrderFluxClick() {
      this.channelAgeShow = false
      this.channelSexShow = false
      this.channelEquipmentShow = false
      this.channelRegionShow = false
      this.channelOrderFlux()
      if (this.activeTypeNum == 1) {
        this.numberShow = false
        this.getPaySucsList()
      } else if (this.activeTypeNum == 2) {
        this.payShow = false
        this.getPayList()
      } else {
        this.channeShow = false
        this.getChannelList()
      }
    },


    goInfo() {
      this.$router.push({
        name: 'INFO',
        query: {
          title: '版本详情',
          value: this.salesTransactionInfo.sysver.sysverId,
        }
      })
    },

    changNums() {
      if (this.changAppNum == this.salesTransactionInfo.tfs.length) {
        this.changAppNum = 10
      } else {
        this.changAppNum = this.salesTransactionInfo.tfs.length
      }
    },

    changSceNums() {
      if (this.accountsNum == this.salesTransactionInfo.cks.length) {
        this.accountsNum = 10
      } else {
        this.accountsNum = this.salesTransactionInfo.cks.length
      }
    },

    async getPaySucsList() {
      this.loadingnNumberShow = true;
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = '/console/stats/order/pay/sucs?limit=' + this.sucsLimit + '&channelAccountId=' + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = '/console/stats/order/pay/sucs?limit=' + this.sucsLimit + '&bizType=' + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);
      if (resData.result != 200) {
        this.loadingnNumberShow = false;
        return;
      }
      let obj = {
        id: 'myTransactionChart',
        name: '支付数量（近' + this.sucsLimit + '天）',
        types: resData.data.xaxis,
        data: resData.data.series,
        width: (this.getViewPortHeight - 600) + 'px',
        height: '400px'
      }
      this.salesTransaction = obj
      this.numberShow = true
      this.loadingnNumberShow = false;
    },

    async getPayList() {
      this.loadingnPayShow = true;
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = '/console/stats/order/pay/moneys?limit=' + this.moneyLimit + '&channelAccountId=' + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = '/console/stats/order/pay/moneys?limit=' + this.moneyLimit + '&bizType=' + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);

      if (resData.result != 200) {
        this.loadingnPayShow = false;
        return;
      }
      let obj = {
        id: 'myDayTransactionChart',
        name: '支付金额（近' + this.moneyLimit + '天）',
        types: resData.data.xaxis,
        data: resData.data.series,
        width: (this.getViewPortHeight - 600) + 'px',
        height: '400px'
      }
      this.salesDayTransaction = obj
      this.payShow = true
      this.loadingnPayShow = false;
    },

    async getChannelList() {
      this.loadingnChanneShow = true;
      let reqUri = ''
      if (this.channelPieAccountId) {
        reqUri = '/console/stats/channel/adput/flux?limit=' + this.channeLimit + '&channelAccountId=' + this.channelPieAccountId + '&bizType=' + this.bizType
      } else {
        reqUri = '/console/stats/channel/adput/flux?limit=' + this.channeLimit + '&bizType=' + this.bizType
      }
      const {data: resData} = await this.$get(reqUri);
      if (resData.result != 200) {
        this.loadingnChanneShow = false;
        return;
      }
      let obj = {
        id: 'myChanneTransactionChart',
        name: '渠道流量（近' + this.channeLimit + '天）',
        types: resData.data.xaxis,
        data: resData.data.series,
        width: (this.getViewPortHeight - 600) + 'px',
        height: '400px'
      }
      this.channeTransaction = obj
      this.channeShow = true
      this.loadingnChanneShow = false;
    },

    async maneyInfd() {
      this.loading = true;
      const {data: resData} = await this.$get("/console/info2");
      this.loading = false;
      if (resData.result != 200) return;
      if(resData.data.ranks){
        resData.data.ranks.slice(0,5)
      }
      this.salesTransactionInfo = resData.data
      this.info = resData.data.info;
    },

    changActiveItem(e) {
      this.activeTypeNum = e
      if (e == 1) {
        this.numberShow = false
        this.getPaySucsList()
      } else if (e == 2) {
        this.payShow = false
        this.getPayList()
      } else {
        this.channeShow = false
        this.getChannelList()
      }
    },
    changActiveModeItem(e) {
      this.bizType = e

      this.sucsLimit = 15
      this.moneyLimit = 15
      this.channeLimit = 15
      this.channelPieAccountId = 0
      this.channelOrderFluxClick()
    },

    moneyNumChang(e) {
      this.payShow = false
      this.getPayList()
    },

    sucsNumChang() {
      this.numberShow = false
      this.getPaySucsList()
    },

    channeNumChang() {
      this.channeShow = false
      this.getChannelList()
    },
  }
}
</script>

<style scoped lang="scss">
.icon_infos {
  cursor: pointer;
  width: 100%;
  position: relative;
  display: flex;

  .info_lefts {
    width: 392px;
    margin-right: 20px;

    .item_box {
      padding: 10px;
      border: 1px solid rgba(215, 215, 215, 1);
      margin-bottom: 20px;
      border-radius: 4px;
      font-size: 14px;

      .name_tabs {

      }

      .bor_yas {
        padding: 2px 5px;
        border-radius: 4px;
        background: #3a8ee6;
        color: #ffffff;
        margin-left: 5px;
      }

      .nowMore {
        i {
          transform: rotate(0deg);
          transition: all 0.3s linear;
        }
      }

      .active_box {
        i {
          transition: all 0.3s linear;
          transform: rotate(90deg);
        }
      }
    }

    .info_list_tabs {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 15px;

      .info_item {
        display: flex;
        padding: 5px;
        width: 170px;
        background: rgba(242, 242, 242, 1);
        margin-right: 10px;
        margin-bottom: 10px;

        .left_box {
          width: 40px;
          height: 40px;
          margin-right: 10px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
        }

        .right_infos {
          width: 95px;

          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .info_item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  .box_infos {
    margin-bottom: 10px;
    width: calc(100% - 420px);
  }
  .car_insdoasd{
    .chang_box_content .chin_box_title{
      padding-bottom: 0;
     .box_info_tabs  .box_name_tabs{
        margin-bottom: 20px;
      }
    }
  }

  .active_Info_name {
    display: flex;
    align-items: center;

    .top_head {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .box_info_infos {
      div:nth-child(1) {
        margin-bottom: 5px;
      }

      div:nth-child(2) {
        font-size: 12px;
        color: #959595;
      }
    }
  }

  .pay_number {
    min-height: 680px;
  }

  .chineac_box {
    display: flex;
    align-items: center;
    height: 35px;
    width: 450px;
    border-bottom: 1px solid rgba(242, 242, 242, 1);
    margin-bottom: 20px;

    div {
      height: 35px;
      line-height: 35px;
      width: 150px;
      text-align: center;
      font-size: 14px;
      border-radius: 4px 4px 0 0;
    }

    .active_div {
      background-color: rgba(242, 242, 242, 1);
    }
  }

  .chang_box_content {
    display: flex;
    flex-wrap: wrap;

    .chin_box_title {
      padding: 15px;
      border: 1px solid rgba(215, 215, 215, 1);
      border-radius: 4px;
      margin-bottom: 20px;

      .div_name {
        font-size: 13px;
        margin-bottom: 10px;
      }

      .box_info_tabs {

        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .box_name_tabs {
          padding: 10px;
          min-width: 98px;
          background: rgba(242, 242, 242, 1);
          text-align: center;
          margin-right: 20px;
          border-radius: 4px;
          div {
            font-size: 12px;
          }

          .content_box {
            margin-top: 5px;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
    }
  }

  .pie_car {
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 3px;
    width: 230px;
    height: 240px;
    padding: 0 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .cakeBox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .line {
    width: 94%;
    height: 0;
    border-bottom: 1px solid rgba(215, 215, 215, 1);
    margin-bottom: 40px;
  }

  .clasdsad_infasas {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .Rate_num {
      font-size: 12px;
      font-weight: 400;
    }
  }

}

.info_tans_congdsd{
  font-family: Xiaozhuan;
  font-size: 50px;
}


.tab_box_info{
  margin-left:20px;
  border:1px solid #d7d7d7;
  padding: 15px;
  height: 236px;
  //height: calc(100% - 20px);
   .tab_tr{
     display: flex;
     align-items: center;
     text-align: center;
     font-size: 13px;
     //border-left: 1px solid rgba(0,0,0,0.2);
     border-right: 0;
     border-bottom: 0;
     border-top: 0;
     div{
       padding:8px 0;
       color: #333333;
       border-bottom: 1px solid rgba(0,0,0,0.05);
     }
     div:nth-child(1){
       width: 40px;
       //border: 1px solid rgba(0,0,0,0.2);
       //border-right: 0;
       //border-top: 0;
       //border-left: 0;
     }
     div:nth-child(2){
       width: 100px;
       padding:8px 5px;
       //border: 1px solid rgba(0,0,0,0.2);
       //border-top: 0;
       //border-right: 0;
       //border-left: 0;
       overflow: hidden;
       text-overflow: ellipsis;
       white-space: nowrap;
     }
     div:nth-child(3){
        width:50px;
       // border: 1px solid rgba(0,0,0,0.2);
       //border-top: 0;
       //border-right: 0;
       //border-left: 0;
     }
     div:nth-child(4){
       width:50px;
       //border-right: 0;
       //border: 1px solid rgba(0,0,0,0.2);
       //border-top: 0;
       //border-left: 0;
     }
     .one{
       color:#D9001B ;
     }
     .two{
       color: #027DB4;
     }
     .three{
       color:#8080FF ;
     }
   }
  .tip_name{
    font-size: 13px;
    margin-bottom: 10px;
  }
}


</style>